import React from "react";
import { Field, useFormikContext } from "formik";
import { Input } from "components/bootstrap";
import { Select } from "components/common";
import { DATA_LAKE_INCLUSION_TYPE, INDEXER_INCLUSION_TYPE, BOTH_INCLUSION_TYPE } from "data-lake/Constants";
const INCLUSION_TYPE_OPTIONS = [
  { value: DATA_LAKE_INCLUSION_TYPE, label: "Must exclude: Search Cluster" },
  { value: INDEXER_INCLUSION_TYPE, label: "Must include: Search Cluster" },
  { value: BOTH_INCLUSION_TYPE, label: "Include All" }
];
const InclusionTypeField = () => {
  const {
    errors,
    setFieldValue,
    values: { inclusionType }
  } = useFormikContext();
  return /* @__PURE__ */ React.createElement(Field, { name: "inclusion_type" }, () => /* @__PURE__ */ React.createElement(
    Input,
    {
      help: "Type of message to be retrieved",
      id: "inclusion-type",
      error: errors.inclusionType,
      label: "Filter Retrieval by Original Destination"
    },
    /* @__PURE__ */ React.createElement(
      Select,
      {
        id: "inclusionType",
        name: "inclusionYype",
        placeholder: "Select type of retrieval filter",
        options: INCLUSION_TYPE_OPTIONS,
        onChange: (option) => {
          setFieldValue("inclusionType", option);
        },
        value: inclusionType
      }
    )
  ));
};
export default InclusionTypeField;
